import { Skeleton } from '@monksflow/monks-ui';

import { REEL_SESSION_COLUMNS } from './columns';

/** Mirrors `ReelSessionRow`'s height and columns so the swap to loaded rows shifts nothing. */
export const ReelSessionRowSkeleton = () => (
  <div
    data-testid="reel-session-row-skeleton"
    className="flex items-center gap-sm border-b border-border px-xs py-sm last:border-b-0"
  >
    <Skeleton className="h-10 w-14 shrink-0 rounded-md" />
    <Skeleton className="h-4 min-w-0 flex-1" />
    <div className={`hidden shrink-0 sm:block ${REEL_SESSION_COLUMNS.status}`}>
      <Skeleton className="h-5 w-20 rounded-full" />
    </div>
    <div className={`hidden shrink-0 md:block ${REEL_SESSION_COLUMNS.created}`}>
      <Skeleton className="h-3 w-24" />
    </div>
    <div className={`hidden shrink-0 lg:block ${REEL_SESSION_COLUMNS.owner}`}>
      <Skeleton className="h-4 w-28" />
    </div>
    <span className={`shrink-0 ${REEL_SESSION_COLUMNS.actions}`} aria-hidden />
  </div>
);
